import { render, staticRenderFns } from "./BiotSavartViz.vue?vue&type=template&id=54c92390&scoped=true"
import script from "./BiotSavartViz.vue?vue&type=script&lang=js"
export * from "./BiotSavartViz.vue?vue&type=script&lang=js"
import style0 from "./BiotSavartViz.vue?vue&type=style&index=0&id=54c92390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c92390",
  null
  
)

export default component.exports